import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a997b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  ref: "paymentConfirmation"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-title is-title-shrink" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "body-content is-size-4" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 mb-5 is-size-5 notification is-danger is-light"
}
const _hoisted_8 = { class: "custom-card-title has-text-weight-bold" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "frame3-sub-title" }
const _hoisted_12 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "frame3-sub-title" }
const _hoisted_15 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { class: "frame3-sub-title" }
const _hoisted_18 = {
  key: 4,
  class: "center mb-2 mt-2"
}
const _hoisted_19 = { class: "status-indicator" }
const _hoisted_20 = { class: "frame3-sub-title mb-3" }
const _hoisted_21 = {
  key: 5,
  class: "unknown-currency-warning mb-3"
}
const _hoisted_22 = { class: "has-text-warning-dark has-text-weight-bold" }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = { class: "transaction-list-description" }
const _hoisted_26 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_27 = {
  key: 0,
  class: "ml-2 mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_WorkflowIndicator = _resolveComponent("WorkflowIndicator")!
  const _component_TransactionItem = _resolveComponent("TransactionItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", {
        class: _normalizeClass(["modal-card-head", _ctx.type])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.modalTitle), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
        })
      ], 2),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.showPendingTopUpWarning)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$gettext(
                "You already have a pending top-up. Please either pay or delete it before proceeding"
              )), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.statusTitle), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["confirm-icon-container", { 'mb-2': _ctx.isTopUp }])
          }, [
            _createVNode(_component_fa_icon, {
              icon: _ctx.icon,
              class: "confirm-icon fa-thin"
            }, null, 8, ["icon"])
          ], 2),
          _createElementVNode("p", {
            class: _normalizeClass(["amount has-text-weight-bold is-size-4", { cm: _ctx.transactionsTags.includes('barter') }]),
            innerHTML: _ctx.amountSentence
          }, null, 10, _hoisted_9),
          (_ctx.showRequesterInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$gettext("by")), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.requesterName), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showRecipientInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("h2", _hoisted_14, _toDisplayString(_ctx.recipientLabel), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.recipientName), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.topUpStatusMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.topUpStatusMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.showReconversionStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_WorkflowIndicator, {
                    format: "large",
                    stages: _ctx.reconversionStatuses,
                    current: _ctx.reconversionStatus,
                    size: 17,
                    spacing: 25
                  }, null, 8, ["stages", "current"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.dateFormat), 1),
          (_ctx.isUnknownCurrency)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$gettext(
                  "This transaction has an unrecognized currency. Please contact your administrator."
                )), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasMultipleTransactions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$gettext(
                  "Payment was done in %{nbTransactions} transactions:",
                  { nbTransactions: _ctx.transactions.length }
                )), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction) => {
                  return (_openBlock(), _createBlock(_component_TransactionItem, {
                    key: transaction,
                    transaction: transaction,
                    mode: "small"
                  }, null, 8, ["transaction"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("footer", _hoisted_26, [
        (_ctx.showTopUpActions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "button custom-button-modal has-text-weight-medium",
                id: "delete",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelTopUpRequest && _ctx.cancelTopUpRequest(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Delete")), 1)
              ]),
              _createElementVNode("button", {
                class: "button custom-button-modal has-text-weight-medium",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payTopUpRequest && _ctx.payTopUpRequest(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Pay")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showApproveButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "button custom-button-modal has-text-weight-medium",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleApprove && _ctx.handleApprove(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Approve")), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button custom-button-modal has-text-weight-medium",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$modal.close()))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Ok")), 1)
        ])
      ])
    ])
  ], 512))
}